interface StaticMenuItem {
  name: string;
  route: string;
  type: 'dynamicPage' | 'externalLink';
}

export const staticMenuItems: StaticMenuItem[] = [
  {
    name: 'My account',
    route: 'Frontastic.Frontend.Master.Account.index',
    type: 'dynamicPage',
  },
  {
    name: 'Wishlist',
    route: 'Frontastic.Frontend.Master.Account.wishlists',
    type: 'dynamicPage',
  },
  {
    name: 'Store locator',
    route: '/store-locator',
    type: 'externalLink',
  },
];

export const getTileToRenderOnMobile = (tiles) => {
  if (!Array.isArray(tiles) || !tiles.length) {
    return null; // No tiles available
  }

  // Filter tiles that have either promoBackgroundColor or promoBackgroundImage
  const validTiles = tiles.filter((tile) => tile?.promoBackgroundColor || tile?.promoBackgroundImage);
  if (!validTiles.length) {
    return null; // No valid tiles after filtering
  }

  const [firstTile, secondTile] = validTiles;
  // Scenario 1: Both tiles are hidden on mobile
  if (firstTile?.promoHideOnMobile === true && secondTile?.promoHideOnMobile === true) {
    return null;
  }
  // Scenario 2: First tile is hidden, second is not
  if (firstTile?.promoHideOnMobile === true) {
    return secondTile || null; // Return the second tile if available
  }
  // Scenario 3: Second tile is hidden, first is not
  if (secondTile?.promoHideOnMobile === true) {
    return firstTile;
  }
  // Scenario 4: Both tiles are visible
  return firstTile;
};
